module.exports = __webpack_public_path__ + "static/media/Premium-02.bfba72bb.png";